










































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { exportJson2Excel } from '@/utils/excel'
import {
  formatJson,
  resetObjValue2NoneString,
  checkNoneString,
  setTimeRange,
  timeToString
} from '@/utils/tool'
import { getTubiList } from '@/api/trade/trade'
import { Form } from 'element-ui'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'

@Component({
  name: 'CoinManage'
})
export default class extends mixins(DateOption) {
  // api data
  private params = {
    uid: '',
    user_name: '',
    createDateStart: '',
    createDateEnd: '',
    page: 1,
    pageCount: 20
  }
  private updateParams = {
    uid: '',
    count: 0,
    isAccumulated: '',
    remark: ''
  }
  // component data
  tableLoading = false
  private tableData: any[] = []
  private selectedData: any[] = []
  private dateArray = ['', '']
  private totalCount = 0
  private updateFormVisible = false
  tableHeight: number = 800
  private rules: any = {
    uid: [{ required: true, message: '请填写UID', trigger: 'blur' }],
    count: [{ required: true, message: '请输入兔币数量', trigger: 'blur' }]
  }
  // lifecycle
  async created() {
    let [start, end] = setTimeRange(30 * 24 * 3600 * 1000).map(item => timeToString(item))
    this.dateArray = [start, end]
    this.params.createDateStart = start
    this.params.createDateEnd = end
    this.getTableData()
    // this.getAccountStatus()
    // this.getAreaList()
  }
  mounted() {
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.setTableHeight)
    })
  }
  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 75 - filterDom.getBoundingClientRect().bottom
  }
  // methods
  async getTableData() {
    this.tableLoading = true
    let res = await getTubiList(this.params)
    this.tableData = res.data.dataList
    this.totalCount = res.data.pageInfo.totalCount
    this.tableLoading = false
  }

  async handleExcel() {
    // let res: any = await getAccountList({
    //   page: 1,
    //   pageCount: 3000
    // })
    // if (res.status.code === 0) {
    //   setTimeout(() => {
    //     this['$message'].success('导出成功!')
    //   }, 200)
    // } else {
    //   this['$message'].error('导出失败!')
    //   return
    // }
    // const filterVal: string[] = [
    //   'id',
    //   'accountId',
    //   'certName',
    //   'applePwd',
    //   'iphoneCount',
    //   'itouchCount',
    //   'status',
    //   'info',
    //   'createDate',
    //   'creatorName'
    // ]
    // const theader: string[] = [
    //   'ID',
    //   '开发者账号',
    //   '证书',
    //   '专用密码',
    //   'iPhone可安装数量',
    //   'iPad可安装数量',
    //   '状态',
    //   '信息',
    //   '创建时间',
    //   '创建人'
    // ]
    // const list = res.data.dataList
    // const data = formatJson(filterVal, list)
    // exportJson2Excel(theader, data)
  }
  updateUserCoin() {
    // 更新用户兔币
  }
  handleDateChange(date: string[]) {
    this.params.createDateStart = date && date[0]
    this.params.createDateEnd = date && date[1]
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    let [start, end] = setTimeRange(30 * 24 * 3600 * 1000).map(item => timeToString(item))
    this.params = {
      uid: '',
      user_name: '',
      createDateStart: start,
      createDateEnd: end,
      page: 1,
      pageCount: 20
    }
    this.dateArray = ['', '']
    this.getTableData()
  }
  handleAdd() {
    this.updateFormVisible = true
  }
  handleSelectionChange(list: any[]) {
    console.log(list)
    this.selectedData = list
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.id)
    tempSelectList = this.selectedData.map(item => item.id)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.id)) this.selectedData.push(item)
    })
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleUpdateAll() {
    // this.setAccount(this.selectIds)
  }
  updateCoin(item: any) {
    console.log(item)
    this.updateFormVisible = true
  }
  // close dialog, clear data
  handleFormClose() {
    this.cancelUpdateForm()
  }
  cancelUpdateForm() {
    (this.$refs['updateParams'] as Form).resetFields()
    this.updateFormVisible = false
  }
  confirmUpdateForm() {
    (this.$refs['updateParams'] as Form).validate(valid => {
      if (valid) {
        this.updateUserCoin()
      } else {
        this['$message'].warning('请填写完成后再提交!')
        return false
      }
    })
  }
  // computed
  get showMultiSelect() {
    return this.selectedData.length > 1
  }
  get selectCount() {
    return this.selectedData.length
  }
  get selectIds() {
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    let ids = t.join(',')
    return ids
  }
}
